import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <span>© 2026 Jaydeep Kaushik</span>
      <span>Built with React &amp; Three.js</span>
    </footer>
  );
}

export default Footer;
